import React from "react";
import PaymentCardNapPage from "./payment-card-nap-page";
import PaymentCodeNapPage from "./payment-code-nap-page";
import PaymentMomoNapPage from "./payment-momo-nap-page";
import PaymentBankNapPage from "./payment-bank-nap-page";

export default function PaymentNapPage() {

  return <div>
    <PaymentBankNapPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentMomoNapPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentCodeNapPage/>
    <div className="h-10 bg-[#eef0f3]"/>
    <PaymentCardNapPage/>
  </div>;
}
